export default "__VITE_ASSET__Cw0IQ7t6__"